module.exports = __webpack_public_path__ + "img/window-frame-open.4270e127.svg";